import { getProductPayload } from './product'

export default (tracker) => ({
  async clickedBundleCta(customisedProduct, title) {
    await tracker.track('Clicked Bundle CTA', {
      title,
      ...getProductPayload(customisedProduct),
    })
  },
})
